export default __webpack_public_path__ + "static/media/5.675d56c0.jpg";